'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px;\n  background-color: ', ';\n  border-bottom: 1px solid #E8EBED;\n  z-index: 20;\n\n  display: grid;\n  grid-auto-flow: columns;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 1em;\n  align-items: center;\n\n  & ', ' {\n    justify-self: end;\n  }\n  & ', ' {\n    display: none;\n    justify-self: begin;\n  }\n  & ', ' {\n    display: none;\n    justify-self: end;\n  }\n\n  @media ', ' {\n    grid-template-columns: 1fr 10fr 1fr;\n    padding: 20px;\n\n    & ', ',\n    & ', ' {\n      display: initial;\n    }\n    & ', ' {\n      display: none;\n    }\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px;\n  background-color: ', ';\n  border-bottom: 1px solid #E8EBED;\n  z-index: 20;\n\n  display: grid;\n  grid-auto-flow: columns;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 1em;\n  align-items: center;\n\n  & ', ' {\n    justify-self: end;\n  }\n  & ', ' {\n    display: none;\n    justify-self: begin;\n  }\n  & ', ' {\n    display: none;\n    justify-self: end;\n  }\n\n  @media ', ' {\n    grid-template-columns: 1fr 10fr 1fr;\n    padding: 20px;\n\n    & ', ',\n    & ', ' {\n      display: initial;\n    }\n    & ', ' {\n      display: none;\n    }\n  }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LangSelect = require('./LangSelect');

var _MainMenu = require('./MainMenu');

var _MobileMenu = require('./MobileMenu');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var Header /* ComponentType<{| logo: string, children: React.Node |}> */ = exports.Header = (0, _styledComponents2.default)(function (props) {
  return React.createElement(
    'header',
    { className: props.className },
    React.createElement(
      'a',
      { href: '/' },
      React.createElement('img', { src: props.logo })
    ),
    props.children
  );
})(_templateObject, _styles.styles.colors.lightbg, _MobileMenu.HamburgerButton, _MainMenu.MainMenu, _LangSelect.LangSelect, _styles.styles.media.laptop, _MainMenu.MainMenu, _LangSelect.LangSelect, _MobileMenu.HamburgerButton);
Header.displayName = 'Header';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Header.js
// module id = 615
// module chunks = 0